import { colors, typo } from '@design-system/styles'
import styled from '@emotion/styled'

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* gap: 24px;

  width: 500px;
  padding: 24px; */

  .title {
    ${typo.heading05};
    color: var(--Colors-Gray-900);
    text-align: center;
    font-weight: 700;
    margin: 10px 0;
  }
`

const S = { Wrap }

export default S
